import styled from '@emotion/styled';
import { Box, FormControlLabel, Grid, Typography } from '@mui/material';
import { purple } from 'Styles/colors';

export const PrintContainer = styled.div`
  padding: 20px;
  background: white;

  @media print {
    padding: 5px 20px;
    background: white;

    @page {
      margin: 15mm;
      size: portrait;
    }
  }
`;

export const PrintImage = styled.img`
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
`;

export const ContentContainer = styled.div`
  display: block;
`;

export const FooterContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 20px;
  left: 25px;
`;

export const PrintSection = styled(Grid)`
  padding: 13px 9px;
  display: flex;
  margin-left: 0;
  position: relative;
  margin-bottom: 20px;

  &:not(:nth-child(1)):nth-child(odd) {
    padding-left: 10px;
  }

  &.MuiGrid-root.MuiGrid-root > .MuiGrid-item {
    padding-left: 5px;
  }

  &.MuiGrid-root::before {
    content: '';
    border: 1px solid #f5f5f5;
    border-radius: 5px;
    width: ${(props) => (props?.containerWidth ? props.containerWidth : '99%')};
    height: 96%;
    position: absolute;
    margin-left: -7px;
    margin-top: -10px;
  }
`;

export const PrintSectionGroup = styled.div`
  border: 1px solid #f5f5f5;
  border-radius: 5px;
`;

export const PrintTextFieldLabel = styled(Typography)`
  letter-spacing: 0.1px;
  color: rgba(0, 0, 0, 0.87);
  margin-left: 2px;
  font-size: 12px;
  line-height: 1.2;
  margin-top: 10px;
  font-family: 'Karla';
  margin-bottom: 7px;
`;

export const PrintTextField = styled(Box)`
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 8px;
  margin-top: 5px;
  font-size: 12px;
  line-height: 1.5;
  min-height: ${(props) => (props.rows ? props.rows * 1.5 : 1.5)}em;
  color: rgba(0, 0, 0, 0.87);
  white-space: pre-wrap;
  word-wrap: break-word;
`;

export const PrintableCheckboxFormLabel = styled(FormControlLabel)`
  .MuiCheckbox-root {
    padding: 1px 10px;
    align-self: flex-start;
  }

  .MuiTypography-root {
    font-size: 12px;
    font-family: 'Karla';
  }

  .MuiSvgIcon-root {
    font-size: 16px;
    color: ${purple._900};
    margin-left: -1px;
  }

  &.Mui-disabled {
    .MuiTypography-root {
      color: black;
      font-family: 'Karla';
    }

    .MuiSvgIcon-root {
      background-color: #ededed;
    }

    .custom-unchecked-checkbox {
      background-color: #ededed;
      border: 1px solid #d6d6d6;
    }
  }
`;

export const PrintableRadioFormLabel = styled(FormControlLabel)`
  color: black;
  .MuiRadio-root {
    padding: 1px 10px;
  }

  .MuiTypography-root {
    font-size: 12px;
  }
`;

export const UncheckedRadio = styled.div`
  border-radius: 10px;
  border: 1px solid ${purple._900};
  opacity: 1;
  width: 10px;
  height: 10px;
`;

export const CheckedRadio = styled.div`
  height: 3px;
  width: 3px;
  border: 5px solid ${purple._900};
  border-radius: 50%;
`;

export const UncheckedCheckbox = styled.div`
  width: 10px;
  height: 10px;
  border: 1px solid #8c8d8d;
  border-radius: 2px;
  margin-top: 2px;
`;

export const PrintGridBody = styled(Grid)`
  width: 98%;
  margin-left: 3px;

  .PrintSection {
  }

  .PrintSection-MemberInformation {
    justify-content: space-between;
    padding-right: 15px;
  }

  .PrintSection-ConnectionContactInformation {
    .PrintInputGrid-PrimaryMemberConnectionReason,
    .PrintInputGrid-SecondaryMemberConnectionReason {
      width: 100%;
    }
  }

  .PrintSection-Medical,
  .PrintSection-BehavioralHealth,
  .PrintSection-Benefits,
  .PrintSection-SDOH,
  .PrintSection-DetailsAdditionalInformation {
    .formGroup-Pharmacy,
    .formGroup-Dentistry,
    .formGroup-In-HomeCareAssistance {
      margin: 5px 0;
    }
  }

  .PrintSection-Medical {
    height: auto;
    row-gap: 0px;

    .formGroup-Pharmacy {
      .label-0 {
        width: 103%;
      }
    }
    .formGroup-Dentistry {
      margin-top: -20px;
    }
    .formGroup-In-HomeCareAssistance {
      width: 113%;
      padding-left: 0px;
    }

    .PrintInputGrid-Pharmacy {
      margin-left: -35px;
    }

    .PrintInputGrid-In-HomeCareAssistance {
      margin-left: -5px;
    }

    .PrintInputGrid-DurableMedicalEquipmentDME {
      margin-top: -15px;
    }
  }

  .PrintSection-BehavioralHealth {
    row-gap: 0px;
    height: 85px;
    padding-left: 10px;
  }

  .PrintSection-SDOH {
    row-gap: 0px;

    .PrintInputGrid-Housing {
      label-1 {
        width: 106%;
      }
    }
  }

  .PrintSection-ConnectionDestination {
    padding-left: 10px;
    height: auto;
    max-height: 130px;
    row-gap: 0px;
    .formGroup-Community-BasedOrg {
      width: 103%;
      marginleft: -10px;
    }
  }

  .PrintSection-Benefits {
    row-gap: 0px;
    height: 105px;
    padding-left: 10px;
  }

  .PrintSection-TransfertoPlanRecommended {
    row-gap: 0px;
    height: 120px;
  }

  .PrintSection-DetailsAdditionalInformation {
    row-gap: 0px;
    padding-left: 10px;
  }
`;
